import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  GovernmentAllocationEntryProductCategoryCurrencyValidationSchema,
  GovernmentAllocationEntryProductCategoryQuantityValidationSchema,
} from '@/features/privateCompanies/pages/CompanyGovernmentAllocations/schemas/update.schema'
import { transformUpdatedProductCategory } from '@/features/privateCompanies/pages/CompanyGovernmentAllocations/Update/utils/transformNewProductCategories'
import { CompanyGovernmentAllocationEntryProductCategory } from '@/features/privateCompanies/types/companyGovernmentAllocationEntry.type'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type UseUpdateGovernmentAllocationEntryProductCategoryProps = {
  governmentAllocationId: string
  entryProductCategory: CompanyGovernmentAllocationEntryProductCategory
  governmentAllocationCurrencyRestricted: boolean | undefined,
  onSuccess: () => void
  onError: (error: AxiosError) => void
}

export const useUpdateGovernmentAllocationEntryProductCategory = ({
  governmentAllocationId,
  entryProductCategory,
  governmentAllocationCurrencyRestricted,
  onSuccess,
  onError,
}: UseUpdateGovernmentAllocationEntryProductCategoryProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateGovernmentAllocationEntryProductCategory'],
    mutationFn: async (form: GovernmentAllocationEntryProductCategoryCurrencyValidationSchema | GovernmentAllocationEntryProductCategoryQuantityValidationSchema) => {
      const government_allocation_entry = {
        entry_product_categories_attributes: [transformUpdatedProductCategory(form, entryProductCategory, governmentAllocationCurrencyRestricted)],
      }

      return privateAxios.put(`/billing/government_allocation_entries/${governmentAllocationId}`, {
        government_allocation_entry,
      })
    },
    onSuccess,
    onError,
  })
}
